<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag'
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: OUTBOUND_NFE_TAXATION_GROUP_NEW_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.outboundNfeTaxationGroup;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function(taxationGroup) {
      // console.log("tax group",taxationGroup);
      var filtered = this.deepFilterEntryWithAllowedFieldsForMutation(taxationGroup, this.entry.validations);
      //gambi por enquanto !!!
      filtered.cultureIdsAttributes = taxationGroup.cultureIdsAttributes;
      filtered.subCultureIdsAttributes = taxationGroup.subCultureIdsAttributes;
      // console.log("tax group fil",filtered);
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_OUTBOUND_NFE_TAXATION_GROUP_MUTATION,
          variables: {
            input: filtered,
          }
        })
        .then(response => {
          var errors = response.data.createTaxationGroup.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created");
            this.resetForm();
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const OUTBOUND_NFE_TAXATION_GROUP_NEW_QUERY = gql `
  query {
    accountContext{
      outboundNfeTaxationGroup {
        id
        name
        itemType
        ncmId
        cultureIdsAttributes
        cultures {
          id
          name
        }
        subCultureIdsAttributes
        itemIdsAttribute
        subCultures{
          id
          name
          additionalInfo
        }
        validations
      }
    }
    globalContext {
      allCultures {
        id
        name
      }
      allCultureItemTypes {
        text
        value
      }
    }
  }
`;

const CREATE_OUTBOUND_NFE_TAXATION_GROUP_MUTATION = gql `
  mutation($input: TaxationGroupCreateInputObject!) {
    createTaxationGroup(input: $input) {
      taxationGroup{
        id
      }
      errors
    }
  }
`;


</script>

<style scoped></style>
